<template>
<div class="mt-3 d-flex" style="margin-top:5px;display:flex;" @click="veri(id)">
    <span class="estado">
        <canvas id="canvas"  ref='canvas' width='56' height='56'></canvas>
    <div v-if="image"><img :src="`https://hyreads.com${image.image}`" alt=""> </div>
    <div v-if="video">
      <video  preload="metadata">
               <source :src="`https://hyreads.com${video.video}#t=0.5`" type="video/mp4" />
              <source :src="`https://hyreads.com${video.video}#t=0.5`" type="video/ogg" />
                <source :src="`https://hyreads.com${video.video}#t=0.5`" type="video/webm" />
           </video>
    </div>
    <div v-if="!image && !video" class="text" :class="background" v-html="last_story"></div>
    </span>
    <div class="contenido">
        <div class="nombre">{{nombre}}</div>
        <div class="fecha" v-if="getHumanDate1(hora) == getHumanDate1(new Date())">Today at {{getHumanDate(hora)}}</div><div class="fecha" v-else>Yesterday at {{getHumanDate(hora)}}</div>
    </div>

</div>
</template>

<script>
import moment from 'moment';
import VueMomentsAgo from '../../moments-ago.vue'
export default {
    components: {
      VueMomentsAgo
    },
    data(){
        return {
           
        }

    },
    // filters: {
    //   moment: function(date){
    //       return moment(String(date)).format('LT')
    //   }

    //     },
    
  mounted(){
    this.hacerCirculo({
      lados: this.nEstados,
      nPrimario:this.nNuevos
    })
  },
  computed:{
    getId(){
      return this.$store.getters.getIndex(this.id)
    }

  },
  beforeDestroy(){
    const ctx = this.$refs.canvas.getContext('2d');
    ctx.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
  },
  props:{
    stories:{},
    id:{},
    image:{},
    video:{},
    last_story:{},
    background:{},
    miestado: {type:Boolean},
    idEstado:{type:String, required: true},
    nombre: {type: String, required:true},
    hora: {type: String, required:true},
    nEstados: {type: Number},
    nNuevos: {type:Number},
    nStatus:{},
    nPersona:{}
  },
  watch:{
    nEstados(nuevo, old){
      this.hacerCirculo({
        lados: nuevo,
        nPrimario:this.nNuevos
      });
    },
    nNuevos(newValue, old){
      this.hacerCirculo({
        lados: this.nEstados,
        nPrimario:newValue
      });
    },
  },
  methods:{
      veri(id){
      
        this.$router.push("/story/"+ this.getId);


      },
      getHumanDate : function (date) {
                return moment(String(date)).format('LT')
            },
            getHumanDate1 : function (date) {
                return moment(String(date)).format('DD/MM/YYYY')
            },

    hacerCirculo(attr){
      const colorPrimario='#01a3a4';
      const colorSecundario='#aaa';

      const ctx = this.$refs.canvas.getContext('2d');

      const blanco=(Math.PI*2)/50;
      const segmento = (Math.PI*2)/attr.lados; //valor constante de cada segmento

      const startAngle= attr.anguloInicial || blanco;  //primer segmento inicia luego del espacio en blanco
      const endAngle= attr.anguloFinal || segmento;	//primer segmento

      if(attr.lados==1){
        ctx.beginPath();
        ctx.arc(28.5,27.5,26,0,Math.PI*2);
        ctx.lineWidth=2;
        ctx.strokeStyle = (attr.nPrimario>0)?colorPrimario:colorSecundario;
        ctx.stroke();

        return;
      }

      ctx.beginPath();
      ctx.arc(28.5,27.5,26,startAngle,endAngle)
      ctx.lineWidth=2;
      ctx.strokeStyle = (attr.nPrimario>0)?colorPrimario:colorSecundario;
      ctx.stroke();

      // if(n) n--;
      // else n=lados;

      attr.n= attr.n-1 || attr.lados; //n dismiyue su valor en cada iteracion

      if(attr.n>1)
        this.hacerCirculo({
          lados        : attr.lados,
          anguloInicial: endAngle+blanco,
          anguloFinal  : endAngle+segmento,
          n            : attr.n,
          nPrimario    : attr.nPrimario-1
        });
          //cada nuevo segmento inicia despues del espacio en blanco
      }
  }
}
</script>

<style lang="scss" scoped>
.estado{
    cursor: pointer;
    padding: 10px 15px;
    position: relative;

img {
      background: grey;
      width: 45px;
      height: 45px;
      border-radius: 50%;
    //   position:absolute;
}
video {
      // background: grey;
      width: 45px;
      height: 45px;
      border-radius: 50%;
    //   position:absolute;
}
.text {

     width: 45px;
      height: 45px;
      color:white;
      position:relative;
      margin:0;
      text-align:center;
      overflow-wrap:break-word;
      font-size:8px;
      overflow: hidden;

   

    max-height: 45px;
    border-radius: 50%;
}
// .text p::before {
//     content: '';
//     float:right;
//     height:45px;
//     width:45px;
//     shape-outside: polygon(
//         2% 0%,
//         100% 0%,
//         100% 100%,
//         2% 100%,
//         50% 94%,
//         76.6% 82.7%,
//         94% 65.6%,
//         100% 50%,
//         94% 65.6%,
//         100% 50%,
//         94% 32.6%,
//         76.6% 17.3%,
//         50% 6%


//     );
//     shape-margin:7%;
// }
      canvas{
     top: 5px;
      left: 10px;
      position: absolute;
      z-index: 1;
      transform: rotate(268deg);
      }
      .contenido {
      position:absolute;
      top:2.5em;
      left: calc(45px + 15px + 0.7em);
      .nombre, .fecha {
        text-align: left
      }
      .fecha {
        color:grey ;
        font-size: 0.75em;
      }
      }


}

.gradient-1 {
  background: linear-gradient(pink, orange);
}

.gradient-2 {
  background: linear-gradient(19deg, #21D4FD 0%, #B721FF 100%);
}

.gradient-3 {
  background: linear-gradient(45deg, #FA8BFF 0%, #2BD2FF 52%, #2BFF88 90%);
}

.gradient-4 {
  background-image: linear-gradient(90deg, #FF9A8B 0%, #FF6A88 55%, #FF99AC 100%);
}

.gradient-5 {
  background-image: linear-gradient(0deg, #FFDEE9 0%, #B5FFFC 100%);
}

.gradient-6 {
  background-image: linear-gradient(19deg, #3EECAC 0%, #EE74E1 100%);
}

.gradient-7 {
  background-image: linear-gradient(225deg, #FF3CAC 0%, #784BA0 50%, #2B86C5 100%);
}

.gradient-8 {
  background-image: linear-gradient(0deg, #08AEEA 0%, #2AF598 100%);
}
</style>
